import { Link } from 'react-router-dom';
import { useAuthCtx } from '../context/AuthContext';
import { getHomeRoute } from '../lib/getHomeRoute';

function BrandMark({ size }: { size: number }) {
  // Lotus mark from assets/new-branding/arevina/icon-master.png. /brand-mark-sm.png (168x130, 27 KB) is
  // the on-screen size; the 856x662 /brand-mark.png (437 KB) was downloaded on every page for a 30 px mark.
  const height = size;
  const width = size;
  return (
    <img
      src="/brand-mark-sm.png"
      alt=""
      width={width}
      height={height}
      className="block shrink-0 object-contain"
      aria-hidden
      draggable={false}
    />
  );
}

/**
 * Brand lockup: mark + "arevina" wordmark (Plus Jakarta Sans 700).
 * Full PNG lockups live at /brand-logo-light.svg and /brand-logo-dark.svg.
 */
export default function AppLogo({
  className = '',
  clickable = true,
  markSize = 30,
}: {
  className?: string;
  clickable?: boolean;
  /** Mark height in px (default 30 — matches wordmark cap-height). */
  markSize?: number;
}) {
  const { profile } = useAuthCtx();
  const to = getHomeRoute(profile);

  const lockup = (
    <span
      className={`inline-flex min-w-0 max-w-full items-center gap-2.5 ${className}`}
      aria-label="Arevina"
    >
      <BrandMark size={markSize} />
      <span
        className="inline-flex shrink-0 items-center whitespace-nowrap tracking-[0.04em] text-[var(--text-primary)]"
        style={{
          height: markSize,
          fontFamily: 'var(--font-brand)',
          fontWeight: 700,
          fontSize: Math.round(markSize * 0.72),
          lineHeight: 1,
        }}
      >
        arevina
      </span>
    </span>
  );

  if (clickable) {
    return (
      <Link
        to={to}
        className="inline-flex min-w-0 max-w-full items-center hover:opacity-90 transition-opacity"
      >
        {lockup}
      </Link>
    );
  }

  return lockup;
}
